import { EPagePermission } from './permission'

export const managementMenusMap = {
  usage: {
    href: '/app/managements/usage',
    text: 'Usage',
    permission: EPagePermission.Usage,
  },
  batchAccounts: {
    href: '/app/managements/batch-accounts',
    text: 'Batch Accounts',
    permission: EPagePermission.BatchAccounts,
  },
  customAccount: {
    href: '/app/managements/custom-account',
    text: 'Custom Account',
    permission: EPagePermission.CustomAccount,
  },
  deleteEmail: {
    href: '/app/managements/delete-email',
    text: 'Delete Email',
    permission: EPagePermission.DeleteEmail,
  },
  paymentPlatform: {
    href: '/app/managements/payment-platform',
    text: 'Payment Platform',
    permission: EPagePermission.PaymentPlatform,
  },
  products: {
    href: '/app/managements/products',
    text: 'Products',
    permission: EPagePermission.Products,
  },
  customerPayment: {
    href: '/app/managements/customer-payment',
    text: 'Customer Payment',
    permission: EPagePermission.CustomerPayment,
  },
  moderation: {
    href: '/app/managements/moderation',
    text: 'Moderation',
    permission: EPagePermission.Moderation,
  },
  template: {
    href: '/app/managements/template',
    text: 'Template',
    permission: EPagePermission.Template,
  },
  videoTemplate: {
    href: '/app/managements/video-template',
    text: 'Video Template',
    permission: EPagePermission.Template,
  },
  voiceCategory: {
    href: '/app/managements/voice-category',
    text: 'Voice Category',
    permission: EPagePermission.VoiceCategory,
  },
  voice: {
    href: '/app/managements/voice',
    text: 'Voice',
    permission: EPagePermission.Voice,
  },
}

export type TManagementMenuKey = keyof typeof managementMenusMap

export const defaultMenusKey = Object.keys(
  managementMenusMap,
) as TManagementMenuKey[]
